import { render, staticRenderFns } from "./SimplePagination.vue?vue&type=template&id=b2a75b8e&scoped=true&"
import script from "./SimplePagination.vue?vue&type=script&lang=js&"
export * from "./SimplePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a75b8e",
  null
  
)

export default component.exports